import Header from './Header';
import SearchContent from './SearchContent';
const Home = () => {

    return ( 
        <>
        <Header />
        <SearchContent />
        </>
     );
}
 
export default Home;